export enum MultiZetSize {
  NORMAL = 'normal',
  BIG = 'big'
}
